
export { default as lensIndex } from "./lensIndex.js"
export { default as pipe } from "./pipe.js"
export { default as set } from "./set.js"